export const SERVER_URL = 'https://stg.admin.leaf-wellness.org/api/v1';
